export default [
  {
    koNm: '최민기',
    engNm: 'Choi Minki',
    position: '의무팀장',
    birthday: '1991년 02월 23일',
    education: '동신대학교',
    img: 'staff_01'
  }, {
    koNm: '노경욱',
    engNm: 'Noh Gyeonguk',
    position: '트레이너',
    birthday: '1996년 02월 05일',
    education: '건양대학교',
    img: 'staff_02'
  }, {
    koNm: '김지원',
    engNm: 'Kim Jiwon',
    position: '트레이너',
    birthday: '1999년 01월 04일',
    education: '우송대학교',
    img: 'staff_03'
  }, {
    koNm: '이백한',
    engNm: 'Lee Baekhan',
    position: '통역관',
    birthday: '1999년 02월 04일',
    education: 'California Riverside\nSFDS',
    img: 'staff_04'
  }, {
    koNm: '박상옥',
    engNm: 'Park Sangok',
    position: '장비사',
    birthday: '1991년 03월 20일',
    education: '상명대학교',
    img: 'staff_05'
  }, {
    koNm: '박영균',
    engNm: 'Park Yeongkyun',
    position: '주치의',
    birthday: '1980년 02월 16일',
    education: '순천에스병원\n대표원장',
    img: 'staff_06'
  }
]
